import { handle400Statuses, sendApiRequest } from './api';
import { logNetRequest } from '@utils/usefulFuncs';

// Self-service API key management. Called with the SPA's normal Bearer JWT --
// NOT with an API key (the endpoints 403 a tornado_sk_ request). Backend
// contract: docs/api-keys-api-contract.md.

// POST -> 201 with the full secret (`data.api_key`) returned EXACTLY ONCE.
// 422 with { error } on missing/duplicate name.
export const createApiKey = async ({ name, expires_at }) => {
  const URL = 'v1/api_keys';
  const form = { name, expires_at: expires_at || null };
  const { status, data, error } = await sendApiRequest('post', URL, form);
  logNetRequest(status, data, error);
  handle400Statuses(status);
  return { status, data, error };
};

// GET -> 200 with metadata only (never the secret).
export const fetchApiKeys = async () => {
  const URL = 'v1/api_keys';
  const { status, data, error } = await sendApiRequest('get', URL);
  logNetRequest(status, data, error);
  handle400Statuses(status);
  return { status, data, error };
};

// DELETE -> 204 on soft revoke, 404 if not one of the user's active keys.
export const revokeApiKey = async (id) => {
  const URL = `v1/api_keys/${id}`;
  const { status, data, error } = await sendApiRequest('delete', URL);
  logNetRequest(status, data, error);
  handle400Statuses(status);
  return { status, data, error };
};
